export namespace TOOGGLE_DESCRIPTION_TYPE {
    export const SHORT_DESCRIPTION = "short"
    export const LONG_DESCRIPTION = "long"
}
export type TOOGGLE_DESCRIPTION_TYPE = typeof TOOGGLE_DESCRIPTION_TYPE[keyof typeof TOOGGLE_DESCRIPTION_TYPE]


// WEBPACK FOOTER //
// ./src/state/pricing/ProductDescription.ts